import React from 'react';
import cn from 'classnames';
import { string, number, arrayOf, shape, func, bool } from 'prop-types';

import Tab from './components/Tab';
import styles from './styles.module.scss';

function TabBar({ className, tabs, currentTabId, overrideClasses, onTabClick, lineSeparator, notFullWidth }) {
  return (
    <div
      className={cn('row', styles.tabsBar, className, {
        [styles.lineSeparator]: lineSeparator
      })}>
      {tabs.map(({ id, className: classN, title, icon, value, overrideClasses: overrideC, buttonProps }) => (
        <Tab
          className={classN}
          key={id}
          text={title}
          icon={icon}
          id={id}
          value={value}
          active={currentTabId === id}
          overrideClasses={overrideClasses || overrideC}
          onClick={onTabClick}
          notFullWidth={notFullWidth}
          buttonProps={buttonProps}
        />
      ))}
    </div>
  );
}

TabBar.defaultProps = {
  className: '',
  tabs: ''
};

TabBar.propTypes = {
  currentTabId: number.isRequired,
  className: string,
  lineSeparator: bool,
  notFullWidth: bool,
  overrideClasses: bool,
  tabs: arrayOf(
    shape({
      title: string,
      id: number
    })
  ),
  onTabClick: func
};

export default TabBar;
